'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cancelComponentSignReport = exports.toReport = exports.componentUsageReporting = exports.cancelReport = exports.report = exports.cancelReportComponentUsage = exports.reportComponentUsage = exports.cancelReportUsage = exports.reportUsage = exports.tcssReport = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _index = require('../type/index');

var _tcss_report = require('./tcss_report');

var _tcss_report2 = _interopRequireDefault(_tcss_report);

var _report_usage = require('./report_usage');

var _report_usage2 = _interopRequireDefault(_report_usage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 如果有window.cancel_spaui_component_report = true，那默认就是false的不进行setComponentSign处的上报
var canReportUsage = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.cancel_spaui_component_report ? false : true;
var canReportComponentUsage = true;

var tcssReport = exports.tcssReport = _tcss_report2.default;

var reportUsage = exports.reportUsage = function reportUsage() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (canReportUsage) {
        (0, _report_usage2.default)(config);
    }
};
var cancelReportUsage = exports.cancelReportUsage = function cancelReportUsage() {
    canReportUsage = false;
};

var reportComponentUsage = exports.reportComponentUsage = function reportComponentUsage(config) {
    setTimeout(function () {
        if (canReportComponentUsage) {
            reportUsage(config);
        }
    }, Math.random() * 500 + 1000);
};
var cancelReportComponentUsage = exports.cancelReportComponentUsage = function cancelReportComponentUsage() {
    canReportComponentUsage = false;
};

// ---废弃，兼容以前 begin---
var report = exports.report = _tcss_report2.default;
var cancelReport = exports.cancelReport = cancelReportUsage;
var componentUsageReporting = exports.componentUsageReporting = reportUsage;
var toReport = exports.toReport = function toReport() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$libraryName = config.libraryName,
        libraryName = _config$libraryName === undefined ? 'spaui' : _config$libraryName,
        componentName = config.componentName,
        componentVersion = config.componentVersion;

    var reportable = config.reportable || config.__toReport;

    if ((0, _index.isUndefined)(reportable) || reportable) {
        reportUsage({
            scope: libraryName,
            name: componentName,
            version: componentVersion
        });
    }
};
var cancelComponentSignReport = exports.cancelComponentSignReport = cancelReportComponentUsage;
// ---废弃，兼容以前 end---

exports.default = {
    // ---废弃，兼容以前 begin---
    report: report,
    cancelReport: cancelReport,
    componentUsageReporting: componentUsageReporting,
    toReport: toReport,
    recordUsage: reportUsage,
    cancelComponentSignReport: cancelComponentSignReport,
    // ---废弃，兼容以前 end---

    tcssReport: tcssReport,
    reportUsage: reportUsage,
    cancelReportUsage: cancelReportUsage,
    reportComponentUsage: reportComponentUsage,
    cancelReportComponentUsage: cancelReportComponentUsage
};